export default {
  namespaced: true,
  state: {
    supported: false,
  },
  getters: {
  },
  mutations: {
    SET_WEBP_SUPPORT(state, supported) {
      state.supported = supported
    },
  },
  actions: {
    checkWebpSupport({ commit }) {
      const supportsWebp = this.$isSupportsWebp()
      commit('SET_WEBP_SUPPORT', supportsWebp)
    },
  },
}
